import { memo, useMemo } from 'react'
import TextareaAutoSize from 'react-textarea-autosize'
import cn from 'classnames'
import { IInputProps as BaseInputProps, Input } from 'components/extend/Input'
import { IconTooltipError } from 'components/IconTooltip'
import { isRequiredError } from 'helpers/error'

import s from './PasswordInput/PasswordInput.module.less'
import cs from 'src/common.module.less'

interface IInputProps {
  maxLength?: number
  maxRows?: number
  minRows?: number
  style?: any
  value?: string
}

export interface ITextareaInputProps extends Omit<BaseInputProps<IInputProps>, 'type' | 'value'>, IInputProps {
  height?: number
  testId?: string
}

export const TextareaInput = memo(function TextareaInput({
  minRows = 3,
  maxRows = 15,
  maxLength,
  height,
  inputRef,
  error,
  testId,
  ...props
}: ITextareaInputProps) {
  const inputProps = useMemo<IInputProps>(
    () => ({
      minRows,
      maxRows,
      maxLength,
      style: {
        marginTop: '8px',
        marginBottom: '8px',
        height
      },
      ref: inputRef
    }),
    [minRows, maxRows, maxLength, height, inputRef]
  )

  // @ts-ignore
  return (
    <Input
      {...props}
      error={error}
      // @ts-ignore
      inputComponent={TextareaAutoSize}
      inputProps={inputProps}
      testId={testId}
      type="text"
      postfix={
        <div className={cn(cs.flex, cs.marginL4)}>
          {typeof error === 'string' && !isRequiredError(error) ? (
            <IconTooltipError className={s.errorIcon} placement="right">
              {error}
            </IconTooltipError>
          ) : null}
        </div>
      }
    />
  )
})
